import { db } from '../../firebase'
import { actions } from '../../redux'

export const voteObserver = arg => {
    const collectionName = 'votes'
    const dispatch = arg[0]
    const collection = db.collection(collectionName).orderBy('timestamp')
    collection.onSnapshot(
      querySnapshot => {
        const userData = []
        for (const change of querySnapshot.docChanges()) {
          const data = {
            ...change.doc.data(),
          }
          data.timestamp = change.doc.data().timestamp.toDate()
          
          switch (change.type) {
            case 'modified':
              dispatch(actions.UPDATE_VOTE(data))
              break
            case 'removed':
              dispatch(actions.REMOVE_VOTE(data))
              break
            default:
              userData.push(data)
          }
        }
        if (userData.length > 0) {
          dispatch(actions.ADD_VOTE(userData))
        }
      },
      err => {
        console.log(err)
      }
    )
  }